import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import cn from 'classnames'
import { StaticLayout } from '../../../component'
import helper from '../term-and-condition/helper/term-and-condition.helper'
import style from './accessibility.module.scss'

export const Accessibility = ({ data }) => {
    const { html } = helper.treatFiles(data)

    return (
        <StaticLayout hideSmartBanner>
            <div className={cn(style.wrapper, 'page-wrapper')}>
                <div
                    className="html"
                    // eslint-disable-next-line
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        </StaticLayout>
    )
}

Accessibility.propTypes = {
    data: PropTypes.object.isRequired,
}

export default Accessibility

export const query = graphql`
    query($regex: String!) {
        allMarkdownRemark(filter: { fileAbsolutePath: { regex: $regex } }) {
            edges {
                node {
                    html
                    headings {
                        value
                        depth
                    }
                }
            }
        }
    }
`
